import { QFile } from "./QFile";
import { QRFC } from "./QRFC";

export class QFileExists extends QRFC {
  constructor() {
    super();
  }

  InitFileExists(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  SetParams(org, user, directory, files) {
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("dir", directory);
    this.AddEncodedParameter("data", files);
  }

  GetCallName() {
    return "qfileexists";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    //   var success = true;
    //   if (r == 'failure')
    //       success = false;

    callBackObj.FileExistsComplete(r);
  }
}
